import React, { FunctionComponent, useState, useCallback, useEffect } from 'react';
import { Spring } from 'react-spring/renderprops';

import Icon from '../Icons';

import { AccordionWrapper } from './styles';

const Accordion: FunctionComponent<{
  open: boolean;
  isPrefix?: boolean;
  title: any;
  clickHandler: Function;
  icon?: string;
  referenceClass?: string;
  subtitle?: string;
}> = (props) => {
  const [isOpen, toggle] = useState(props.open ? props.open : false);
  const clickHandler = useCallback(() => toggle(!isOpen), [isOpen]);

  useEffect(() => {
    toggle(props.open);
  }, [props.open]);

  return (
    <AccordionWrapper className={isOpen ? 'accordion-wrapper with-shadow' : 'accordion-wrapper'}>
      <div
        className={`title flex justify-content-s ${props.referenceClass}`}
        onClick={props.clickHandler ? () => props.clickHandler(props.title) : clickHandler}
        onKeyPress={clickHandler}
        role="button"
        tabIndex={0}
      >
        {props.isPrefix && isOpen && (
          <div className="icon-wrapper">
            <i className="material-icons title-icon">keyboard_arrow_up</i>
          </div>
        )}
        {props.isPrefix && !isOpen && (
          <div className="icon-wrapper">
            <i className="material-icons title-icon">keyboard_arrow_down</i>
          </div>
        )}
        <div className="flex">
          <p className="accordian-title">{props.title}</p>
          {props.icon ? (
            <span className="ml16">
              <Icon name={props.icon} />
            </span>
          ) : null}
        </div>
        {!props.isPrefix && isOpen && <i className="material-icons title-icon">keyboard_arrow_up</i>}
        {!props.isPrefix && !isOpen && <i className="material-icons title-icon">keyboard_arrow_down</i>}
      </div>
      {props.subtitle ? <p className="smaller font-light-grey pl16 pb16 cursorP">{props.subtitle}</p> : null}
      <Spring to={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}>
        {(style: any) => (
          <div className={isOpen ? 'outer-content open' : 'outer-content'} style={style}>
            <div className="inner-content">{props.children}</div>
          </div>
        )}
      </Spring>
    </AccordionWrapper>
  );
};

export default Accordion;
